import Alpine from 'alpinejs';
import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, EffectCards, FreeMode, Keyboard } from 'swiper/modules';

Alpine.data('swiper', (options) => ({
  swiper: null,

  initSwiper() {
    const modules = [Keyboard];
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    // Add required modules based on options
    if (options.arrows) modules.push(Navigation);
    if (options.pagination) modules.push(Pagination);
    if (options.autoplay) modules.push(Autoplay);
    if (options.effect === 'fade') modules.push(EffectFade);
    if (options.effect === 'cards') modules.push(EffectCards);
    if (options.freemode) modules.push(FreeMode);
    
    const swiperConfig = {
      modules,
      direction: options.direction,
      loop: options.looping,
      slidesPerView: options.slidesPerView,
      spaceBetween: options.spaceBetween * 16, // Convert rem to px
      centeredSlides: options.centered,
      freeMode: options.freemode,
      effect: options.effect,
      grabCursor: options.grabCursor !== 'none',
      allowTouchMove: options.grabCursor !== 'none',
      keyboard: {
        enabled: true,
        onlyInViewport: false
      }
    };
    
    // Set height based on device and uniform height option
    const height = isMobile ? options.heightMobile : options.heightDesktop;
    
    if (options.uniformHeight && height) {
      // Both uniform height and specific height set
      const finalHeight = height;
      swiperConfig.height = finalHeight;
      this.$el.querySelector('.swiper').style.height = `${finalHeight}px`;
      this.$el.style.setProperty('--swiper-height', `${finalHeight}px`);
    } else if (options.uniformHeight) {
      // Uniform height but no specific height - use defaults
      const defaultHeight = isMobile ? 320 : 480;
      swiperConfig.height = defaultHeight;
      this.$el.querySelector('.swiper').style.height = `${defaultHeight}px`;
      this.$el.style.setProperty('--swiper-height', `${defaultHeight}px`);
    } else if (height) {
      // Specific height but no uniform height
      swiperConfig.height = height;
      this.$el.querySelector('.swiper').style.height = `${height}px`;
    } else {
      // No height specified and no uniform height - use autoHeight
      swiperConfig.autoHeight = true;
      // Remove any height constraints
      this.$el.querySelector('.swiper').style.height = 'auto';
    }
    
    // Effect-specific settings
    if (options.effect === 'fade') {
      swiperConfig.fadeEffect = {
        crossFade: true
      };
      swiperConfig.slidesPerView = 1;
    }
    
    if (options.effect === 'cards') {
      swiperConfig.cardsEffect = {
        perSlideOffset: 8,
        perSlideRotate: 2,
        rotate: true,
        slideShadows: true
      };
      swiperConfig.slidesPerView = 1;
      swiperConfig.centeredSlides = true;
    }
    
    // Navigation arrows
    if (options.arrows) {
      swiperConfig.navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      };
    }
    
    // Pagination
    if (options.pagination) {
      swiperConfig.pagination = {
        el: '.swiper-pagination',
        clickable: true
      };
    }
    
    // Autoplay
    if (options.autoplay) {
      swiperConfig.autoplay = {
        delay: options.duration,
        disableOnInteraction: false
      };
    }
    
    // Responsive breakpoints for slidesPerView
    if (typeof options.slidesPerView === 'number' && options.slidesPerView > 1) {
      swiperConfig.breakpoints = {
        320: {
          slidesPerView: Math.min(1.2, options.slidesPerView)
        },
        640: {
          slidesPerView: Math.min(2, options.slidesPerView)
        },
        768: {
          slidesPerView: options.slidesPerView
        }
      };
    }
    
    this.swiper = new Swiper(this.$el.querySelector('.swiper'), swiperConfig);
  },
  
  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}));